import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.2001 6.59995L16.9 9.89995L18.7 18.8C18.8 19.1 18.7 19.5 18.4 19.7L17.7 20.4C17.2 20.9 16.3 20.7 16.1 20.1L13.5 13.4L10.1 16.8L10.3 19C10.3 19.3 10.2 19.5999 10 19.7999L8.90005 20.9L6.80005 17.4L3.30005 15.3L4.30005 14C4.50005 13.8 4.80005 13.7 5.10005 13.7L7.30005 13.9L10.7 10.5L3.90005 7.89995C3.30005 7.59995 3.10005 6.79995 3.60005 6.29995L4.30005 5.59995C4.50005 5.39995 4.90005 5.29995 5.20005 5.29995L14.1 7.09995L17.4 3.79995C18.2 2.99995 19.4001 2.99995 20.2001 3.79995C21 4.59995 21 5.79995 20.2001 6.59995Z",
		fill: "#1C1C1E"
	})
});
const ForwardRef = forwardRef(SvgFlight);
export default ForwardRef;
